import UrqlClient from '@/app/graphql/client';
import { getSdk } from './sdk.payment';

if (!import.meta.env.VITE_APP_ENDPOINT) new Error('Нет переменной VITE_APP_ENDPOINT');

const client = new UrqlClient(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/ob-payment-service/graphql`);
const sdkPaymentService = getSdk(client);

export * from './sdk.payment';
export default sdkPaymentService;
